module.exports = __webpack_public_path__ + "static/media/history.da0279cd.jpg";